var MainStyle;
(function (MainStyle) {
    MainStyle["Colors"] = "colors";
    MainStyle["Fonts"] = "fonts";
    MainStyle["Button"] = "button";
    MainStyle["Background"] = "background";
    MainStyle["Overlay"] = "overlay";
})(MainStyle || (MainStyle = {}));
// FONTS
export var TextTransform;
(function (TextTransform) {
    TextTransform["None"] = "none";
    TextTransform["Uppercase"] = "uppercase";
    TextTransform["Lowercase"] = "lowercase";
    TextTransform["Titlecase"] = "titlecase";
})(TextTransform || (TextTransform = {}));
export var FontType;
(function (FontType) {
    FontType["Google"] = "google";
    FontType["File"] = "file";
    FontType["Regular"] = "regular";
})(FontType || (FontType = {}));
// BUTTONS
export var RadiusKind;
(function (RadiusKind) {
    RadiusKind["Custom"] = "custom";
    RadiusKind["Square"] = "square";
    RadiusKind["Medium"] = "medium";
    RadiusKind["Rounded"] = "rounded";
})(RadiusKind || (RadiusKind = {}));
export var MeasureUnit;
(function (MeasureUnit) {
    MeasureUnit["Percentage"] = "%";
    MeasureUnit["Pixels"] = "px";
    MeasureUnit["Rem"] = "rem";
    MeasureUnit["Em"] = "em";
})(MeasureUnit || (MeasureUnit = {}));
export var ButtonStyleKind;
(function (ButtonStyleKind) {
    ButtonStyleKind["Solid"] = "solid";
    ButtonStyleKind["Outline"] = "outline";
})(ButtonStyleKind || (ButtonStyleKind = {}));
//# sourceMappingURL=style.types.js.map